import { Patient } from '../models/internal/Patient';
import { Patients } from '../models/internal/Patients';
import { Series } from '../models/internal/Series';
import { SeriesElement } from '../models/internal/SeriesElement';
import { Study } from '../models/internal/Study';
import { StowrsInputElement } from '../services/dicom-upload/stowrs-input-element';

export function extractorByStudyIds(patients: Patients, studyIds: Set<string>): Array<StowrsInputElement> {
    return [...patients.data.values()].flatMap((p: Patient) => extractsFromPatient(p, studyIds));
}

function extractsFromPatient(patient: Patient, studyIds: Set<string>): Array<StowrsInputElement> {
    return [...patient.data.values()].filter((e) => studyIds.has(e.getId())).flatMap((e) => extractsFromStudy(e));
}

function extractsFromStudy(study: Study): Array<StowrsInputElement> {
    return [...study.data.values()].flatMap((s: Series) => extractSFromSerie(s));
}

function extractSFromSerie(serie: Series): Array<StowrsInputElement> {
    return [...serie.data.values()].map((se: SeriesElement) => {
        return {
            studyId: se.getStudyId(),
            seriesId: se.getSeriesId(),
            modality: se.getSeriesModality(),
            body: se.instance,
        };
    });
}
